module.exports = __webpack_public_path__ + "static/media/29DUNON9.132ef6ed.jpg";